const {KitModule, registerModule} = window;

class FullImage extends KitModule {
  constructor($element) {
    super($element, {observer: {threshold: 0.5}});
  }

  onViewportEnter() {
    if (this.$lottiePlayer) {
      this.$lottiePlayer.dotLottie.play();
      this.$lottiePlayer.dotLottie.unfreeze();
    }
  }
}

registerModule('FullImage', FullImage);
